import React, { FC, ReactElement, ReactNode } from 'react';
import classes from './styles/detailPageTabFormSection.module.css';
import { FlexGrid, FlexGridColumn } from '../../../../components/FlexGrid';
import Typography from '../../../../components/Typography';
import isUndefined from 'lodash/isUndefined';

type DetailPageTabFormSectionProps = {
	title: ReactNode;
	rightContent?: ReactElement;
};

const DetailPageTabFormSection: FC<React.PropsWithChildren<DetailPageTabFormSectionProps>> = ({
	title,
	children,
	rightContent,
}) => {
	return (
		<section
			className={classes.section}
			data-layout-component='detailPageTabFormSection'
		>
			<FlexGrid
				spaceBetween
				center
				style={{ minHeight: '32px' }}
				wrap
				gap='tiny'
			>
				<FlexGridColumn>
					<Typography
						headingSize={3}
						bold
					>
						{title}
					</Typography>
				</FlexGridColumn>
				{!isUndefined(rightContent) && <FlexGridColumn end>{rightContent}</FlexGridColumn>}
			</FlexGrid>
			<hr className={classes.hr} />
			{children}
		</section>
	);
};

export { DetailPageTabFormSection };
